import { timeHhMmSsToDayjs } from '@/shared/lib/timeHelper'

import { ShiftFormValues } from './models/ShiftFormValues'

export const defaultShiftValues: Partial<ShiftFormValues> = {
  name: '',
  description: '',
  startDepotId: null,
  finishDepotId: null,
  uiColorId: null,
  runCategoryId: null,
  weightCapacity: 0,
  volumeCapacity: 0,
  costFixed: 0,
  costPerKm: 0,
  costPerHour: 0,
  hiddenCostFixed: 0,
  hiddenCostPerKm: 0,
  hiddenCostPerHour: 0,
  overtimeCostPerHour1: 0,
  overtimeCostPerHour2: 0,
  speedScale: 1,
  targetUtilisation: 0,
  loadTime: timeHhMmSsToDayjs('00:00'),
  unloadTime: timeHhMmSsToDayjs('00:00'),
  overtimeKickIn1: timeHhMmSsToDayjs('00:00'),
  overtimeKickIn2: timeHhMmSsToDayjs('00:00'),
  maxLoads: 0,
  attributeIds: [],
  compartmentIds: [],
  isPaidBreaks: false,
  breakDuration: timeHhMmSsToDayjs('00:00'),
  fatigueModelType: 0,
  workDay: {
    id: 0,
    weekday: 0,
    dayOfWeek: '',
    startTimeEarliest: timeHhMmSsToDayjs('00:00'),
    startTimeLatest: timeHhMmSsToDayjs('00:00'),
    finishTimeLatest: timeHhMmSsToDayjs('00:00'),
    maxDrivingTime: timeHhMmSsToDayjs('00:00'),
    maxWorkingTime: timeHhMmSsToDayjs('00:00'),
    loadTimeEarliest: timeHhMmSsToDayjs('00:00'),
    loadTimeLatest: timeHhMmSsToDayjs('00:00'),
    startTimeEarliestNextDay: false,
    startTimeLatestNextDay: false,
    finishTimeLatestNextDay: false,
    loadTimeEarliestNextDay: false,
    loadTimeLatestNextDay: false,
    minTimeUntilBreak: '00:00',
    maxTimeUntilBreak: '00:00',
    breakDuration: '00:00',
    minPaidTime: timeHhMmSsToDayjs('00:00'),
    isActive: false,
  },
}